import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=11b21c60&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderDetail.vue?vue&type=style&index=0&id=11b21c60&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "11b21c60",
  null
  ,true
)

export default component.exports